import React, { use } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import CheckRounded from '@mui/icons-material/CheckRounded';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import ResidentSettingsProviderContext from 'features/residents/resident-settings/providers/contexts/resident-settings-provider-context';
import styles from './resident-settings-bulk-header.module.scss';

type Props = {
  headerText?: string;
  isSubmitting: boolean;
};

const ResidentSettingsBulkHeader = ({ headerText, isSubmitting }: Props): React.JSX.Element => {
  const { t } = useTranslation('residentsSettings');
  const { getValues } = useFormContext();
  const {
    bulkEditState: { selectedResidentSettings, clearResidentSettings },
  } = use(ResidentSettingsProviderContext);

  return (
    <div className={styles.container}>
      <div className={styles.topHeaderContainer}>
        <div className={styles.actionsContainer}>
          <Button data-testid="cancelButton" variant="text" onClick={clearResidentSettings}>
            {t('details.cancelFormButton')}
          </Button>
          <Button
            data-testid="submitButton"
            startIcon={<CheckRounded />}
            variant="contained"
            type="submit"
            loading={isSubmitting}
            disabled={getValues('bulkScenarioActiveStates').length === 0}
            loadingPosition="start"
          >
            {`${selectedResidentSettings.length} ${t('details.saveFormButton')}`}
          </Button>
        </div>
      </div>
      <Typography variant="h4" data-testid="residentDetailHeader">
        {headerText}
      </Typography>
    </div>
  );
};

export default ResidentSettingsBulkHeader;
